import React from 'react';
import { useIntl } from 'react-intl';

import { Tooltip } from '@xsolla/ui-core';

import { VerticalCenterBlock } from '../../../styled';
import { SelectFieldLabel } from './style';

export const StandardFieldLabel = ({ name }: { name: string }): JSX.Element => {
  const intl = useIntl();
  return (
    <VerticalCenterBlock>
      <SelectFieldLabel>
        {intl.messages[`user-data-base.settings.supplementary-info.field.${name}`]}
      </SelectFieldLabel>
      <Tooltip
        content={intl.messages[`user-data-base.settings.supplementary-info.field.standart-field`]}
        delayEnter={0}
        delayLeave={0}
        offset={6}
        placement="top-center"
      />
    </VerticalCenterBlock>
  );
};
